import { styled } from '@linaria/react';

export default styled.div`
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;

  @media (min-width: 375px) {
    max-width: 499px;
  }

  @media (min-width: 500px) {
    max-width: 799px;
  }

  @media (min-width: 800px) {
    padding-left: 50px;
    padding-right: 50px;
    max-width: 999px;
  }

  @media (min-width: 1000px) {
    padding-left: 60px;
    padding-right: 60px;
    max-width: 1179px;
  }

  @media (min-width: 1080px) {
    padding-left: 60px;
    padding-right: 60px;
    max-width: 1439px;
  }
`;
